import type { IconName } from '../components/Icon'
import type { ClientStatus } from './types'

export type NavItem = {
  id: string
  label: string
  path: string
  icon: IconName
}

/** Primary navigation shown in the sidebar. */
export const PRIMARY_NAV: NavItem[] = [
  { id: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: 'dashboard' },
  { id: 'clients', label: 'Clients', path: '/clients', icon: 'users' },
  { id: 'transport', label: 'Transport', path: '/modules/transport', icon: 'transport' },
  { id: 'timecard', label: 'Time Card', path: '/modules/timecard', icon: 'clock' },
  { id: 'clinical', label: 'Clinical', path: '/modules/clinical', icon: 'clinical' },
  { id: 'activities', label: 'Activities', path: '/modules/activities', icon: 'activities' },
  { id: 'food', label: 'Food', path: '/modules/food', icon: 'food' },
]

export const SECONDARY_NAV: NavItem[] = [
  { id: 'reports', label: 'Reports', path: '/modules/reports', icon: 'reports' },
  { id: 'admin', label: 'Admin', path: '/modules/admin', icon: 'admin' },
  { id: 'billing', label: 'Billing', path: '/modules/billing', icon: 'billing' },
  { id: 'crm', label: 'CRM', path: '/modules/crm', icon: 'crm' },
  { id: 'referrals', label: 'Referrals', path: '/modules/referrals', icon: 'referral' },
  { id: 'tasks', label: 'Tasks', path: '/modules/tasks', icon: 'tasks' },
  { id: 'rpm', label: 'RPM', path: '/modules/rpm', icon: 'activities' },
  { id: 'organize', label: 'Organize', path: '/modules/organize', icon: 'calendar' },
]

const STATUS_CLASS: Record<ClientStatus, string> = {
  Approved: 'badge--approved',
  Visitor: 'badge--visitor',
  Discharged: 'badge--discharged',
  Hold: 'badge--hold',
  Potential: 'badge--potential',
}

export function statusBadgeClass(status: ClientStatus): string {
  return `badge ${STATUS_CLASS[status] ?? ''}`.trim()
}
